"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Input = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const IdUtils_1 = require("./IdUtils");
const styled_components_1 = __importDefault(require("styled-components"));
const HelperTypes_1 = require("./HelperTypes");
const getInputTypeForTypeStructureType = (type) => HelperTypes_1.DataTypeMap[type] || "text";
// TODO: Need a way to raise this styling up to a higher level. Specifically, the `:before` `color`.
// TODO: Fix styles and colors in these components.
const InputBase = styled_components_1.default.input `
  &[type="date"]:before {
    content: attr(placeholder) !important;
    color: #a9a9a9;
    margin-right: 0.5em;
  }

  &[type="date"]:focus:before,
  &[type="date"]:valid:before {
    content: "";
  }
`;
const RatingBase = styled_components_1.default.fieldset `
  flex: 0 0 auto;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  gap: 1em;
  padding: 1em;
  border: 0.05em solid black;
  box-sizing: border-box;
`;
const RatingStarContainer = styled_components_1.default.label `
  &:before {
    content: "★";
    color: #a9a9a9;
    cursor: pointer;
  }

  &:has(input:checked) {
    &:before {
      color: #ffcc00;
    }
  }
`;
const RatingStar = styled_components_1.default.input `
  display: none;
`;
const Input = ({ name, label = "", type = "string", value, onChange, options, allowCustomValue, readonly = false, }) => {
    const convertedType = getInputTypeForTypeStructureType(type);
    const inputUUID = (0, react_1.useMemo)(() => (0, IdUtils_1.getUUID)(), []);
    const optionsList = (0, react_1.useMemo)(() => {
        if (Array.isArray(options)) {
            return options;
        }
        else {
            const { content = [] } = options || {};
            return content.map(({ type }) => type.replace(/['"]/gim, () => ""));
        }
    }, [options]);
    const onChangeInternal = (0, react_1.useCallback)((event) => {
        if (onChange) {
            const { target } = event;
            const { checked, value: inputValue } = target;
            const newValue = convertedType === HelperTypes_1.DataTypeMap.boolean
                ? checked !== null && checked !== void 0 ? checked : false
                : convertedType === HelperTypes_1.DataTypeMap.Rating
                    ? parseInt(inputValue, 10)
                    : inputValue;
            onChange(name, newValue);
        }
    }, [name, convertedType, value, onChange]);
    const cleanValue = (0, react_1.useMemo)(() => convertedType === HelperTypes_1.DataTypeMap.boolean ? value !== null && value !== void 0 ? value : false : value !== null && value !== void 0 ? value : "", [convertedType, value]);
    const styleObj = (0, react_1.useMemo)(() => ({ gridArea: name }), [name]);
    return type === "Rating" ? ((0, jsx_runtime_1.jsxs)(RatingBase, { disabled: readonly, children: [(0, jsx_runtime_1.jsx)("legend", { children: label }), (0, jsx_runtime_1.jsx)(RatingStarContainer, { children: (0, jsx_runtime_1.jsx)(RatingStar, { type: "radio", readOnly: true, value: 1, checked: cleanValue >= 1, onClick: onChangeInternal }) }), (0, jsx_runtime_1.jsx)(RatingStarContainer, { children: (0, jsx_runtime_1.jsx)(RatingStar, { type: "radio", readOnly: true, value: 2, checked: cleanValue >= 2, onClick: onChangeInternal }) }), (0, jsx_runtime_1.jsx)(RatingStarContainer, { children: (0, jsx_runtime_1.jsx)(RatingStar, { type: "radio", readOnly: true, value: 3, checked: cleanValue >= 3, onClick: onChangeInternal }) }), (0, jsx_runtime_1.jsx)(RatingStarContainer, { children: (0, jsx_runtime_1.jsx)(RatingStar, { type: "radio", readOnly: true, value: 4, checked: cleanValue >= 4, onClick: onChangeInternal }) }), (0, jsx_runtime_1.jsx)(RatingStarContainer, { children: (0, jsx_runtime_1.jsx)(RatingStar, { type: "radio", readOnly: true, value: 5, checked: cleanValue >= 5, onClick: onChangeInternal }) })] })) : convertedType === HelperTypes_1.DataTypeMap.boolean ? ((0, jsx_runtime_1.jsx)(InputBase, { readOnly: readonly, placeholder: label, type: convertedType, checked: !!cleanValue, onChange: onChangeInternal, style: styleObj })) : convertedType === HelperTypes_1.DataTypeMap.LongText ? ((0, jsx_runtime_1.jsx)("textarea", { readOnly: readonly, placeholder: label, value: cleanValue, onChange: onChangeInternal, style: styleObj, rows: 5 })) : options && !allowCustomValue ? ((0, jsx_runtime_1.jsxs)("select", { disabled: readonly, value: cleanValue, onChange: onChangeInternal, style: styleObj, children: [(0, jsx_runtime_1.jsx)("option", { value: "", children: label }), optionsList.map((o, index) => ((0, jsx_runtime_1.jsx)("option", { value: o, children: o }, index)))] })) : ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(InputBase, { readOnly: readonly, placeholder: label, type: convertedType, value: `${cleanValue}`, onChange: onChangeInternal, style: styleObj, list: options && allowCustomValue ? inputUUID : undefined }), options && allowCustomValue ? ((0, jsx_runtime_1.jsx)("datalist", { id: inputUUID, children: optionsList.map((o, index) => ((0, jsx_runtime_1.jsx)("option", { value: o }, index))) })) : undefined] }));
};
exports.Input = Input;
